export default function StepsIcon({ className }: { className: string }) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
    >
      <mask
        id="mask0_5613_7019"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} fill="url(#pattern0_5613_7019)" />
      </mask>
      <g mask="url(#mask0_5613_7019)">
        <rect width={24} height={24} fill="#030303" />
      </g>
      <defs>
        <pattern
          id="pattern0_5613_7019"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use xlinkHref="#image0_5613_7019" transform="scale(0.0078125)" />
        </pattern>
        <image
          id="image0_5613_7019"
          width={128}
          height={128}
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
}
